module.exports = __webpack_public_path__ + "assets/img/chartCard-title-light.6f0c8472.svg";